import type { GatewayBrowserClient } from "../gateway.ts";

export type SubagentActiveEntry = {
  runId: string;
  label?: string;
  childSessionKey: string;
  requesterSessionKey: string;
  task: string;
  model?: string;
  createdAt: number;
  startedAt?: number;
  runtimeMs: number;
};

export type SubagentRecentEntry = {
  runId: string;
  label?: string;
  childSessionKey: string;
  task: string;
  model?: string;
  status: string;
  startedAt?: number;
  endedAt?: number;
  runtimeMs: number;
};

export type SubagentsStatusResult = {
  totalActive: number;
  totalRecent: number;
  totalRegistered: number;
  active: SubagentActiveEntry[];
  recent: SubagentRecentEntry[];
  watchdog: {
    running: boolean;
    totalScans: number;
    totalAborted: number;
    paused: boolean;
  };
};

export type SubagentsStatusState = {
  client: GatewayBrowserClient | null;
  connected: boolean;
  subagentsStatusLoading: boolean;
  subagentsStatusError: string | null;
  subagentsStatus: SubagentsStatusResult | null;
};

export async function loadSubagentsStatus(state: SubagentsStatusState) {
  if (!state.client || !state.connected) {
    return;
  }
  if (state.subagentsStatusLoading) {
    return;
  }
  state.subagentsStatusLoading = true;
  state.subagentsStatusError = null;
  try {
    const res = (await state.client.request("subagents.status", {})) as SubagentsStatusResult;
    state.subagentsStatus = res;
  } catch (err) {
    state.subagentsStatusError = String(err);
  } finally {
    state.subagentsStatusLoading = false;
  }
}
